/*
 * @Description: config
 * @Author: yaoxiaoxiao
 * @Date: 2021-03-30 10:55:24
 * @LastEditors: yaoxiaoxiao
 * @LastEditTime: 2021-04-01 16:59:16
 */

// 搜索配置
export const inputList = () => [
  {
    type: 'input',
    label: '短信名称',
    key: 'smsNameFuzzy',
    placeholder: '请输入短信名称',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 30,
    showWordLimit: true
  }
]

// 表格配置
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 的高度
    // height: '500px',
    // table 是否为斑马纹
    stripe: false,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // table 索引 label
    indexLabel: '编号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'smsName',
      label: '短信名称',
      width: '120'
    },
    {
      key: 'smsTag',
      label: '短信标识',
      width: '80'
    },
    {
      key: 'smsContent',
      label: '短信内容',
      tooltip: true,
      width: '320'
    },
    {
      key: 'operator',
      label: '操作用户',
      width: '90'
    },
    {
      key: 'operateTime',
      label: '操作时间',
      width: '120'
    },
    {
      key: 'action',
      label: '操作',
      width: '120',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}
